export default {
  getShiftOfADivisionOfASemester: '/semester/getShiftOfADivisionOfASemester',
  getNameOfASemester: '/semester/getNameOfASemester',
  getDivisionsOfASemester: '/semester/getDivisionsOfASemester',
  getBatchesDetails: '/semester/getBatchesDetails',
  getNamesOfSemesters: '/semester/getNamesOfSemesters',
  getSemestersBySemId: '/semester/getSemestersBySemId'
}
